import { TsDOM as q } from '@/scripts/core/TsDOM'
import {
  scaleValue,
} from '@/scripts/core/global'
import {type StickyHeader } from '@/scripts/theme/sticky-header';
import { SELECTORS } from '@/scripts/core/global';

export class HeaderMenu extends HTMLElement {
  static htmlSelector = 'header-menu'
  header: StickyHeader | null
  hoverSummary?: HTMLElement
  detailsId?: string
  mainDetailsToggle: HTMLElement
  content: HTMLElement
	animations?: Animation[]

  constructor() {
    super()
    this.header = q.rs<StickyHeader>(SELECTORS.headerWrapper)
    this.hoverSummary = q.os('button[data-summary-hover="on"], a[data-summary-hover="on"]', this)
    this.mainDetailsToggle = q.rs('.mega-menu', this)
    this.content = q.rs('button[data-summary-hover="on"], a[data-summary-hover="on"]', this.mainDetailsToggle, 'nextElementSibling')
    this.detailsId = q.oa(this.mainDetailsToggle, 'id')
    this.initHoverSummary()
  }

  initHoverSummary() {
    if (!this.hoverSummary || !this.detailsId) return

    this.hoverSummary.addEventListener('click', (_) => {
      void window.Ucoast.mediaManager.playAllInContainer(this.mainDetailsToggle)
      window.setTimeout(() => {
        void window.Ucoast.mediaManager.playAllInContainer(this.mainDetailsToggle)
      }, 3)
    })

    this.hoverSummary.addEventListener('mouseenter', (_) => {
      void window.Ucoast.mediaManager.playAllInContainer(this.mainDetailsToggle)
      const openMenuId = window.Ucoast.openMenuId
      if (openMenuId && openMenuId === this.detailsId) return
      window.Ucoast.openMenuId = this.detailsId
      this.mainDetailsToggle.setAttribute('open', '')
      this.animations?.forEach((animation) => animation.play())
      void window.Ucoast.mediaManager.playAllInContainer(this.mainDetailsToggle)
    })

    this.mainDetailsToggle.addEventListener('keyup', q.onKeyUpEscape)
  }

  onFocusOut() {
		setTimeout(() => {
			if (!this.contains(document.activeElement)) this.close()
		})
	}

	onToggle() {
		if (!this.animations) this.animations = this.content.getAnimations()

		if (this.mainDetailsToggle.hasAttribute('open')) {
			this.animations.forEach((animation) => animation.play())
		} else {
			this.animations.forEach((animation) => animation.cancel())
		}

    if (!this.header) return
    this.header.preventHide = this.mainDetailsToggle.hasAttribute('open')

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return
    const viewport = window.innerWidth >= 750 ? 'desktop' : 'mobile'
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `calc(${scaleValue(this.header.getBoundingClientRect().bottom, viewport)} * var(--ax))`
    )
	}

	close() {
		this.mainDetailsToggle.removeAttribute('open')
		window.Ucoast.openMenuId = undefined
	}
}
